<template>
    <div id="newlist">
        <div class="title">
            <img src="/static/qmsj/img/new.png" alt="new">新建活动

        </div>
        <form name="from1" id="form1" action="" class="form">
            <label class="padding">选择活动：</label>
            <el-radio-group v-model="form.radio" class="ceping">
                <el-radio :label="1">专家测评</el-radio>
                <!--<el-radio :label="2">家长测评</el-radio>-->
                <!--<el-radio :label="3">会员活动</el-radio>-->
                <!--<el-radio :label="4">潜客活动</el-radio>-->
            </el-radio-group>
            <br>
            <div v-if="allHidden()">
                <label class="padding">活动名称：</label>
                <input class="name input" v-model="form.name" maxlength="20" type="text" placeholder="1-20个文字">
                <br>
                <label class="padding">活动价格：</label>
                <!--<input class="price input" v-model="form.price" v-on:input="handleInput" type="text" placeholder="请输入活动价格"><span style="margin:0 5px">元</span>-->
                <!--<input class="price input" v-if="giftEndtime()" v-model="form.price" type="text" value="199" readonly >-->
                <span style="margin:0 5px" v-if="giftEndtime()">免费</span>
                <!--<input class="price input" v-if="!giftEndtime()" v-model="form.price" type="text" value="9.9" readonly>-->
                <span style="margin:0 5px" v-if="!giftEndtime()">免费</span>
                <br>
                <label class="padding">活动时间：</label>
                <el-date-picker size="mini" style="border: 1px solid #dcdfe6;border-radius:10px;"
                                v-model="form.time"
                                @change="getTime"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd">
                </el-date-picker>
                <br>
                <label class="padding" v-if="giftEndtime()">礼品兑换截止时间：</label>
                <el-date-picker v-if="giftEndtime()" style="width: 132px;border: 1px solid #dcdfe6;border-radius:10px;"
                                size="mini"
                                v-model="form.endtime"
                                type="date"
                                placeholder="截止时间"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
                <br><br>

                <div style="clear: both">
                    <label class="padding " >活动图片：</label>
                    <div v-for ="(item,index) in base64" :key="index" style="display:inline-block;">
                        <span class="span_style" @click="delpic(index)"><i class="el-icon-close"></i></span>
                        <img class="imgpic" :src="item" alt="" >
                    </div>
                    <img class="img_pic" src="/static/qmsj/img/pic.png" alt="pic" @click="startt2">
                    <input type="file" id="img" @change="getPic" style="display: none;">
                </div>

                <!-- <img class="img_pic" src="./pic.png" alt="pic" @click="dialogadd = true"> -->


                <br>
                <label class="padding " v-if="giftEndtime()">赠送礼品：</label>
                <div v-if="giftEndtime()" v-for ="(item,index) in giftData" :key="index+1000" style="display:inline-block;">
                    <span class="span_style" @click="delgift(index)"><i class="el-icon-close" ></i></span>
                    <img class="imgpic" :src="item" alt="" >
                </div>
                <img v-if="giftEndtime()" class="img_pic" src="/static/qmsj/img/pic.png" alt="pic" @click="dialogzeng = true">
                <span v-if="giftEndtime()" style="font-size: 12px;color: red">活动赠品仅限两种</span>

                <br>
                <label class="padding bottom">活动介绍：</label>
                <textarea class="content" v-model="form.desc" name="content" id="value_id" cols="45" rows="5"></textarea>
            </div>
        </form>
        <div v-if="allHidden()" class="bottom_btn">
            <el-button size="medium" class = "btn"  @click="this.showdialog" round><i class="el-icon-view"></i><span class="span">预览</span></el-button>
            <el-button size="medium" class = "btn" v-on:click="formdata" round>确定</el-button>
            <el-button size="medium" class = "btn" v-on:click="reset" round>重置</el-button>
        </div>
        <!-- 添加赠品图片弹框 -->
        <el-dialog
                title="title"
                :visible.sync="dialogzeng"
                width="80%"
                center>
                <span slot="title" class="dialog-title">
                    <div class="demo-input-suffix all">
                            <el-row>
                                <el-col :span="12"><div class="grid">
                                        全部分类:
                                        <el-select class="all_kind" size="small" style="width: 160px;" v-model="search.kind"
                                                   clearable placeholder="全部分类">
                                            <el-option
                                                    v-for="item in good_types"
                                                    :key="item.id"
                                                    :label="item.type_name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                </div></el-col>
                                <el-col :span="12"><div class="grid gridnimei" style="width: 160px;">
                                        <el-input class="all_kind" size="small"
                                                  placeholder="请输入商品名称"
                                                  v-model="search.name">
                                            <div slot="append" class="el-icon-search" v-on:click="searchname"></div>
                                        </el-input>
                                </div></el-col>
                            </el-row>


                    </div>
                </span>
            <span>
                    <el-table
                            ref="multipleTable"
                            :data="tableData.data"
                            tooltip-effect="dark"
                            style="width: 100%"
                            @selection-change="handleSelectionChange" border>
                        <el-table-column
                                type="selection"
                                width="30">
                        </el-table-column>
                        <el-table-column
                                prop="good_num"
                                label="商品编号"
                                width="150"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                prop="good_name"
                                label="商品名称"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                label="图片"
                                align=center>
                            <template slot-scope="scope">
                                <span><img :src="scope.row.mini_imgpath" alt="tu" style="height: 30px;width: 30px;"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="spec"
                                label="规格"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                prop="unit"
                                label="单位"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                prop="real_price"
                                label="销售价格"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                prop="purchase_price"
                                label="采购价"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                prop="prev_purprice"
                                label="上次采购价"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                prop="stock"
                                label="可用库存"
                                align=center>
                        </el-table-column>
                        <el-table-column
                                prop="limit"
                                width="120"
                                label="限量"
                                align=center>
                        <template slot-scope="scope" style="line-height:20px">
                                <el-input-number size="mini" v-model="scope.row.limit" :min="0" :max="scope.row.stock" label="描述文字"></el-input-number>
                        </template>
                        </el-table-column>
                    </el-table>

                <p class="pager"><span>共{{tableData.total}}条记录</span>当前{{tableData.page}}页/共{{tableData.totalpage}}页</p>
                <el-pagination class="f_page"
                               background
                               @current-change="handleCurrentChange"
                               :current-page="tableData.page"

                               layout="prev, pager, next"
                               :total="tableData.total">
                </el-pagination>

                </span>
            <span slot="footer" class="dialog-footer">
                    <el-row>
                        <el-col :span="12"><div style="padding-left: 200px"><el-button @click="dialogzeng = false">取 消</el-button></div></el-col>
                        <el-col :span="12"><div style="padding-right: 200px"><el-button type="success" @click="getgift">确 定</el-button></div></el-col>
                    </el-row>


                </span>
        </el-dialog>
        <!-- 预览的弹框 -->
        <el-dialog
                :title="this.form.name"
                :visible.sync="dialoglook"
                center
                class="phoneImg">
            <span slot="title"></span>
            <span slot="footer"></span>
            <div class="bgParent">
                <div class="bgImg">
                    <div class="title">
                        {{ form.name }}
                    </div>
                    <span class="span" @click="close_span"><i class="el-icon-close"></i></span>
                    <div class="picList">
                        <img v-for="item in base64" :src="item" alt="">
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return{
            value6:"",
            dialogadd:false,
            dialogzeng:false,
            dialoglook:false,
            tableData:{
                data:[],
                page:1,
                total:0,
                totalpage:10,
            },
            isactive:true,
            pagesize:20,
            value1:"",
            good_types:[],
            form:{
                radio:1,
                name:'',
                price:'',
                time:["",""],
                endtime:'',
                desc:''
            },
            search:{
                kind:'',
                name:'',
            },
            base64url:'',
            base64:[],
            giftData:[],
            centre_id:'',//中心ID
            create_user:'',
            multipleSelection:[],
            selectedGift: {},
            token:''
        }
  },
    filters:{
        typename: function (value) {
            if(value == 1) return "专家测评"
            if(value == 2) return "家长测评"
        }
    },
    methods:{
        handleInput(e){
            this.data=e.target.value.replace(/[^\d]/g,'');
        },
        // 确定
        formdata(){
            if(this.checkData()){
                var arr = this;
                let self = this;
                $.ajax({
                    url:process.env.apiUrl + "saas/group/add_group",
                    type:"post",
                    data:{token:this.token,create_user:this.create_user,type:this.form.radio,group_name:this.form.name,price:this.form.price,
                        start_time:this.form.time[0],end_time:this.form.time[1],gift_end_time:this.form.endtime,
                        notes:this.form.desc,g_img:this.base64,gift_gid:this.selectedGift },
                    success:function(response){
                        if(response.status == 1){
                            self.$message.success(response.msg);
                            setTimeout(function(){

                                self.$router.push({
                                    'name':'actset'
                                })

                            },2200)
                        }else{
                            self.$message.error(response.msg);
                        }
                    }
                })
            }
        },
        getTime(val) {
            console.log(val);
            this.form.time=val;//这个Time是在data中声明的，也就是v-model绑定的值
        },
        // 重置
        reset(){
            this.form={radio:1,};
            this.base64=[];
            this.giftData=[];
        },
        // 搜索商品名称
        searchname(){

            this.tableData.page = 1;
            this.loaddata();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.tableData.page = val;
            this.loaddata();
        },
        // 赠品接口

        loaddata(){
            var arr = this;
            console.log(arr.centre_id)

            $.ajax({
                url:process.env.apiUrl + "saas/group/goodsList",
                type:"post",
                data:{
                    token:arr.token,
                    search:arr.search.name,
                    typeid:arr.search.kind,
                    page:arr.tableData.page
                },
                success:function(response){
                    console.log(response)
                    if(response.map.count == 0){
                        arr.tableData.data = [];
                        arr.tableData.total = 0;
                        arr.tableData.totalpage =1;
                    }else{
                        arr.tableData.data = response.data;
                        arr.tableData.total = response.map.count;
                        arr.tableData.totalpage = response.map.pagetotal;
                        arr.good_types = response.good_types;
                    }
                }
            })
        },

        startt2(){
            $('#img').click();
        },
        getPic() {
            let self=this;
            var img = document.getElementById('img');
            var imgFile = new FileReader();
            imgFile.readAsDataURL(img.files[0]);
            imgFile.onload = function () {
                var imgData = this.result; //base64数据
                self.base64.push(imgData);
            }
        },
        // 添加赠品图片
        getgift(){
            //验证赠品
            if(this.multipleSelection.length > 2){
                this.$message.warning("赠品最大仅限两种,请不要过多选择");
                return false;
            }

            let selectedImg = [];
            let selectedGift = {};
            for (let index = 0; index < this.multipleSelection.length; index++) {
                const element = this.multipleSelection[index];
                selectedImg.push(element.mini_imgpath);
                const id = element.id;
                selectedGift[id] = element.limit;
                //判断赠品限量是否填写 不能为0
                if(element.limit == 0){
                    this.$message.warning("商品限量不能为零");
                    selectedImg = [];
                    selectedGift = {};
                    return false;
                }
            }
            this.dialogzeng = false;
            // console.log(selectedGift);
            this.giftData = selectedImg;
            this.selectedGift = selectedGift;
        },
        delpic(index) {
            this.base64.splice(index, 1);
        },
        delgift(index) {
            this.giftData.splice(index, 1);
        },
        showdialog() {
            if(this.base64.length == 0){
                this.$message.warning("请选择图片");
            }else{
                this.dialoglook = true;
            }
        },
        close_span(){
            this.dialoglook = false;
        },
        //隐藏赠品截止日期
        giftEndtime(){
            if(this.form.radio == 1){
                return true;
            }else{
                return false;
            }
        },
        //隐藏会员活动/潜客活动
        allHidden(){
            if(this.form.radio == 3 || this.form.radio == 4) {
                return false;
            }else{
                return true;
            }
        },
        //检查是否为空
        checkData() {
            let re = /^([1-9][0-9]*)+(.[0-9]{1,2})?$/;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
            if(this.form.name == ''){
                this.$message.warning("请输入活动名称")
                return false;
            };
//            if(this.form.price == ''){
//                this.$message.warning('请输入活动价格');
//                return false;
//            };
//            if(!re.test(this.form.price)){
//                this.$message.warning('活动价格请输入数字金额');
//                return false;
//            };

            if(this.form.time[0]== '' || this.form.time[1]== ''){
                this.$message.warning('请输入活动时间');
                return false;
            };

            if(this.base64.length == 0){
                this.$message.warning('请输入活动图片');
                return false;
            };
            // if(this.giftData.length == 0 && this.form.radio == 1){
            //     alert('请输入赠送礼品');
            //     return false;
            // };
            if(this.form.desc == ''){
                this.$message.warning('请输入活动介绍');
                return false;
            };
            if(this.form.endtime == '' && this.form.radio == 1){
                this.form.endtime = this.form.time[1];
                // this.$message.warning('请输入礼品兑换截止时间');
                // return false;
            };
            return true;
        }

    },
    mounted:function(){



        this.centre_id=$.cookie('centre_id')
        this.token=$.cookie('token')

        this.create_user=$.cookie('create_user')
        this.loaddata();
    }

}
</script>

<style type="text/css" >
    .newlist{
        background-color: #fff;
        width: 100%;
        height: 100%;
        padding: 10px;
    }
    .title{
        height: 40px;
        color:rgb(135,127,198);
        font-size: 18px;
        font-weight: bold;
    }
    .title img{
        width: 20px;
        height: 20px;
        position: relative;
        top: 3px;
        margin: 0 10px;
    }
    .form{
        font-size: 14px;
        color:rgb(153,153,153);
        letter-spacing:1px;
    }
    .padding{
        padding-left: 30px;
    }
    .form label{
        display: inline-block;
        height: 30px;
    }
    .ceping{
        padding-right: 10px;
        height: 30px;
        line-height: 30px;
    }
    .aaa{
        border-radius: 7px;
        height: 20px;

        border:1px solid rgb(220,220,220);
    }
    .img_pic{
        width: 120px;
        height: 90px;
    }
    .imgpic{
        width: 90px;
        height: 120px;
        border-radius: 5px;
    }
    .span_style{
        float:right;
        font-weight: bold;
        right: 15px;
        top:-4px;
        position: relative;
        font-size:20px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #999;
        background: #999;
        color: white;
        opacity:0.4;
    }
    .bottom{
        position: relative;
        bottom: 75px;
    }
   #newlist .el-range-editor--mini.el-input__inner{
        width: 210px;
        padding-right: 0;
    }
    .input{
        height: 20px;
        border-radius: 10px;
        border: 1px solid #dcdfe6;
    }
    .input:focus,.name:focus,.price:focus,.content:focus{
        border: 1px solid #8CBB77;
    }
    .name{
        font-size: 12px;
        padding: 3px 10px;
        width: 170px;
    }
    .price{
        font-size: 12px;
        /* color:black;
        font-weight: 600; */
        padding: 3px 10px;
        width: 140px;
    }
    .content{
        border-radius: 10px;
        border: 1px solid #dcdfe6;
        padding: 10px;
    }
    #newlist  .el-input--suffix .el-input__inner{
        padding-right: 0;
    }
    .bottom_btn{
        display: flex;
        justify-content: center;
    }
    .btn{
        margin: 40px 40px 0 40px;
        width: 90px;
    }
    .btn .span{
        position: relative;
        bottom: 2px;
    }
    .btn,.btn:hover{
        background: #8CBB77 !important;
        color:white !important;
        border:0;

    }
    .btn i{
        font-size: 17px;
    }
    .all_kind{
        width: 140px;
    }
  #newlist  .el-input__inner{
        border-radius: 20px;
        border:0;
    }

    #newlist .gridnimei .el-input__inner{
        border-radius: 20px 0 0 20px;
  }
    #newlist  .dialog-title{
        background-color: #8CBB77;
        width: 100%;
        height: 50px;
        display: inline-block;
        padding-top: 10px;
    }
   #newlist .el-dialog__header{
        padding: 0;
    }
    #newlist .all{
        color:white;
    }
    #newlist .el-table thead{
        color:#7C7F85;

    }
    #newlist  .el-table td, #newlist .el-table th{
        padding: 0;
    }
    #newlist .el-checkbox__input.is-checked .el-checkbox__inner,#newlist .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #8CBB77;
        border-color: #8CBB77;
    }
    #newlist  .el-checkbox__inner:hover{
        border-color: #8CBB77;
    }
    #newlist  .el-input-number--mini .el-input-number__decrease,#newlist .el-input-number--mini .el-input-number__increase{
        background: #fff;
        color:#8CBB77;
        border:1px solid #8CBB77;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        line-height:16px;
        top:8px;
        /* margin-left: 10px;
        margin-right: 10px; */
    }
    #newlist .el-checkbox__original{
        display: none;
    }
    #newlist  .el-input-number--mini {
        width: 100px;
        line-height: 26px;
    }
    #newlist .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #8CBB77;
        color: #fff;
    }
    #newlist  .el-pagination.is-background .btn-next,#newlist .el-pagination.is-background .btn-prev,#newlist .el-pagination.is-background .el-pager li{
        margin: 0;
    }
    #newlist .el-button--primary {
        color: #fff;
        background-color: #8CBB77;
        border-color: #8CBB77;
    }
    #newlist .el-button--primary:focus,#newlist .el-button--primary:hover {
        background: #8CBB77;
        border-color: #8CBB77;
        color: #fff;
    }
    #newlist .el-button{
        padding: 8px 15px;
    }
    #newlist  .el-table__body{
        color:rgb(153,153,153);
    }
    .pager{
        color:rgb(153,153,153);
    }
    .pager span{
        margin-right: 5px;
    }
    .f_page{
        text-align: center;
    }
    #newlist .el-date-editor .el-range-input::placeholder {
        color: rgb(153,153,153);
    }
    #newlist .el-input__inner::placeholder{
        color: rgb(153,153,153);
    }
    #newlist .el-radio__input.is-checked .el-radio__inner {
        /* border-color: red; */
        background: #8CBB77;
        border:0;
    }
    #newlist .el-radio__input.is-checked + .el-radio__label {
        color: rgb(153,153,153);
    }
    #newlist .el-radio{
        color:rgb(153,153,153);
        margin-left: 5px;
    }
    #newlist  .el-radio__inner:hover {
        border-color: rgb(153,153,153);
    }
    #newlist  .el-radio__label{
        padding-left: 5px;
    }
    #newlist .el-radio + .el-radio {
        margin-left: 15px;
    }
    #newlist  .el-input-group__append {
        background: white;
        border-radius: 0 20px 20px 0;
        padding: 0 10px 0
    }
    /*#newlist .el-input__inner{*/
        /*padding: 0 0 0 10px;*/
    /*}*/
    .my_span{
        width: 15px;height: 15px;border-radius: 50%;border:1px solid rgb(153,153,153);
    }
    #newlist .el-table .cell{
        line-height: 15px;
    }
    #newlist .el-table th, .el-table tr{
        line-height: 25px;
    }
    #newlist .el-dialog--center .el-dialog__body{
        text-align: center;
    }
    #newlist .el-dialog--center .el-dialog__body{
        padding: 0;
    }
    #newlist .phoneImg .el-dialog--center{
        margin: 0 auto !important;
    }
    #newlist  .phoneImg .el-dialog{
        background: transparent;
        box-shadow: 0 0 0 0;
    }
    #newlist   .phoneImg .bgParent{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    #newlist   .phoneImg .bgImg{
        width: 312px;
        height: 547px;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("/static/qmsj/img/phone.png") no-repeat;
        background-size: 100% 100%;
    }
    #newlist  .phoneImg .el-dialog__footer{
        padding: 0;
    }
    #newlist  .phoneImg .picList{
        width: 217px;
        height: 349px;
        line-height: 0;
        overflow-x: hidden;
        overflow-y: scroll;
        position: absolute;
        top: 94px;
        left: 43px;
    }
    .phoneImg .title{
        width: 217px;
        height: 22px;
        line-height: 22px;
        position: absolute;
        top: 73px;
        left: 43px;
        font-size: 13px;
        color: white;
    }
    .phoneImg .picList img{
        width: 100%;
    }
    .phoneImg .span{
        color: white;
        position: relative;
        bottom: 50px;
        left: 50px;
        float: right;
        font-size: 50px;
    }
    .phoneImg .el-dialog__headerbtn{
        display: none;
    }

</style>



// WEBPACK FOOTER //
// src/pages/ceping/newlist.vue